import { Component } from "@angular/core";
import { WorkerAccount } from "@salaxy/core";
import { SalaxyContext } from "../../../services/index";

/* tslint:disable */
/* TODO: Waiting for rewrite / final implementation */

/** Workers list implementation based on the repository pattern */
@Component({
    selector: "sxdemo-workers",
    template: `<div style="float: right">
    Selected:

    <mat-select placeholder="List of workers" [(ngModel)]="currentId" name="workerList">
        <mat-option *ngFor="let worker of workers" [value]="worker.id">
            {{ worker.avatar.displayName }}
        </mat-option>
    </mat-select>
    &nbsp;
    <button md-raised-button (click)="createNew()">Add new</button>
</div>
<h1>Workers list</h1>
<p>
List of workers using the repository pattern
</p>
<div class="salaxy-row">
    <div class="scol-4">
        <salaxy-worker-list></salaxy-worker-list>
    </div>
    <div class="scol-8">
        <salaxy-worker-detail-edit></salaxy-worker-detail-edit>
    </div>
</div>
`,
})
export class NgWorkersComponent {

    /**
     * Default constructor creates a new WorkersComponent
     * @param context - SalaxyContext
     */
    constructor(
        private context: SalaxyContext,
    ) { }

    public get workers() {
        return this.context.workers.list;
    }

    public get currentId() {
        if (!this.context.workers.current) {
            return null;
        }
        return this.context.workers.current.id;
    }
    public set currentId(value) {
        if (value && (!this.context.workers.current || value !== this.context.workers.current.id)) {
            this.context.workers.setCurrentId(value);
        }
    }

    public createNew() {
        return this.context.workers.newCurrent();
    }

}
